export enum ServiceOrderHeightEnum {
  Zero = 0,
  HalfCellHeight = 1,
  FullCellHeight = 2,
  OneAndAHalfCellHeight = 3,
  MultipleDaysLessThan12h = 40,
  MultipleDaysMoreThan12h = 50
}
